module.exports = __webpack_public_path__ + "img/79_21.c9074dc1.png";